import type { LucideIcon } from 'lucide-react';
import {
  GlobeIcon,
  MessageSquareIcon,
  SparklesIcon,
  UsersIcon,
} from 'lucide-react';
import type { UsageTotalsDTO } from '@shared/schemas/usage';
import { Card, CardContent } from '@/components/ui/card';
import { formatCompactNumber } from '../lib/format';

function TokenKpi({
  icon: Icon,
  label,
  value,
}: {
  icon: LucideIcon;
  label: string;
  value: string;
}) {
  return (
    <Card className="rounded-[var(--radius-surface-3xl)] border-border/70">
      <CardContent className="flex flex-col gap-3 p-5">
        <div className="flex items-center gap-2 text-muted-foreground">
          <span className="flex size-8 items-center justify-center rounded-full bg-muted text-foreground">
            <Icon className="size-4" />
          </span>
          <span className="text-sm font-medium">{label}</span>
        </div>
        <p className="text-2xl font-semibold tracking-tight text-foreground">{value}</p>
      </CardContent>
    </Card>
  );
}

export function UsageTokenKpis({
  conversations,
  events,
  members,
  totals,
  webSearches,
}: {
  conversations: number;
  events: number;
  members?: number;
  totals: UsageTotalsDTO;
  webSearches: number;
}) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <TokenKpi icon={SparklesIcon} label="Tokens consommés" value={formatCompactNumber(totals.totalTokens)} />
      <TokenKpi icon={GlobeIcon} label="Recherches web" value={formatCompactNumber(webSearches)} />
      <TokenKpi icon={MessageSquareIcon} label="Conversations" value={formatCompactNumber(conversations)} />
      <TokenKpi
        icon={UsersIcon}
        label={members === undefined ? 'Événements' : 'Membres actifs'}
        value={formatCompactNumber(members ?? events)}
      />
    </section>
  );
}
